import { useCallback } from 'react';

import { TranslatableText, Translate } from '@dreryk/react-common';
import {
   ContentCopyIcon,
   IconSize,
   IconWrapper,
   Notification,
   NotificationSize,
   NotificationType,
   StyledFlex,
   TestId,
   TextView,
   Tooltip,
} from '@dreryk/react-components';

import { patientTranslationKeys } from '../../translations';

type ComparedPatientPreviewInfoItemProps<VALUE> = {
   readonly label: TranslatableText;
   readonly displayValue: string | undefined;
   readonly value: VALUE | undefined;
   readonly name: string;
   readonly testId: TestId;
   readonly onCopy: (name: string, value: VALUE) => void;
   readonly consistent: boolean;
};

export const ComparedPatientPreviewInfoItem = <VALUE,>(
   props: ComparedPatientPreviewInfoItemProps<VALUE>
): JSX.Element => {
   const handleCopy = useCallback(() => {
      props.onCopy(props.name, props.value!);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.onCopy, props.name, props.value]);
   return (
      <TextView
         testId={props.testId}
         label={
            <StyledFlex gap={'4px'}>
               <Translate>{props.label}</Translate>{' '}
               {props.consistent || props.value === undefined ? null : (
                  <Tooltip
                     testId={'patientInconsistentInfoItem'}
                     content={patientTranslationKeys.unconfirmed.thisValueIsDifferent}
                  >
                     <Notification
                        testId={'patientInconsistentInfoItem'}
                        size={NotificationSize.SMALLER}
                        type={NotificationType.WARNING}
                     />
                  </Tooltip>
               )}
            </StyledFlex>
         }
      >
         <StyledFlex gap={'8px'}>
            {props.value ? (
               <>
                  {props.displayValue}
                  <Tooltip testId={'copy'} content={patientTranslationKeys.unconfirmed.copy}>
                     <IconWrapper size={IconSize.SMALLEST} testId={'copy'} onClick={handleCopy}>
                        <ContentCopyIcon />
                     </IconWrapper>
                  </Tooltip>
               </>
            ) : (
               '-'
            )}
         </StyledFlex>
      </TextView>
   );
};
